import { type BlockCodeData, code } from '@gitbook/doc-core';
import type { Block } from '@gitbook/slate';
import { localStorage } from '@gitbook/util-local-storage';

const CODE_BLOCK_PREFERENCES_STORAGE_KEY = 'codeBlockPreferences';

type CodeBlockPreferences = {
    withLineNumbers?: boolean;
    withCaption?: boolean;
    wrapCode?: boolean;
    expandable?: boolean;
};

type CodeBlockPreferenceKey = keyof CodeBlockPreferences;

function getCodeBlockPreferences(): CodeBlockPreferences {
    return localStorage.get<CodeBlockPreferences>(CODE_BLOCK_PREFERENCES_STORAGE_KEY) ?? {};
}

export function setCodeBlockPreference(key: CodeBlockPreferenceKey, value: boolean) {
    localStorage.set(CODE_BLOCK_PREFERENCES_STORAGE_KEY, {
        ...getCodeBlockPreferences(),
        [key]: value,
    });
}

export function createCodeBlockWithUserPreferences(
    lines: string | Block[],
    data: BlockCodeData = {}
) {
    const preferences = getCodeBlockPreferences();

    const preferenceData: BlockCodeData = {
        lineNumbers: preferences.withLineNumbers ? true : undefined,
        title: preferences.withCaption ? '' : undefined,
        overflow: preferences.wrapCode ? 'wrap' : undefined,
        expandable: preferences.expandable ? true : undefined,
    };

    return code.createCodeBlock(lines, {
        ...preferenceData,
        ...data,
    });
}
